var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOrderIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08762 10.8989C3.39907 8.23022 3.85414 6.22919 4.27617 4.80756C4.62222 3.64188 4.79524 3.05903 5.50479 2.52951C6.21433 2 6.93958 2 8.39006 2H13.21C14.6605 2 15.3858 2 16.0954 2.52951C16.8049 3.05903 16.9779 3.64188 17.324 4.80756C17.746 6.22919 18.2011 8.23022 18.5125 10.8989C18.8795 14.0442 19.0631 15.6168 18.0025 16.8084C16.9419 18 15.223 18 11.7853 18H9.81483C6.37713 18 4.65829 18 3.59766 16.8084C2.53704 15.6168 2.72057 14.0442 3.08762 10.8989Z",
    fill: "white",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13336 5.55542C8.13336 7.02818 9.32725 8.22209 10.8001 8.22209C12.2728 8.22209 13.4667 7.02818 13.4667 5.55542",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13336 5.55542C8.13336 7.02818 9.32725 8.22209 10.8001 8.22209C12.2728 8.22209 13.4667 7.02818 13.4667 5.55542",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrderIc);
export default __webpack_public_path__ + "static/media/purchaseOrder_ic.c43b181f6e1eece0e5c7a7a828d64f4c.svg";
export { ForwardRef as ReactComponent };